import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './index.module.css';
import info from '../../assets/info-v2.svg';

interface Props {
  className?: string;
  label: string;
  onClick: () => void;
}

const InfoLabel: React.FC<Props> = ({ className, label, onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(className, styles.InfoLabel)} onClick={onClick}>
      <img alt={t('information')} src={info} />
      {t(label)}
    </div>
  );
};

export default InfoLabel;
